// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import Glide from '@glidejs/glide';
import { Component, Ref } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ModuleHeaderUi } from '../_components/ui';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TestimonialsModuleUi = class TestimonialsModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Glide instance.
         */
        this.glide = null;
        /**
         * Height of the navbar (in px).
         */
        this.navbarHeight = 0;
    }
    /**
     * Initialises the Glide.
     */
    initGlide() {
        this.glide = new Glide('.testimonials-module__slider');
        this.glide.on('build.after', () => {
            this.updateGlideTrackHeight();
        });
        this.glide.on('run.after', () => {
            this.updateGlideTrackHeight();
            if (this.windowService.isPhone)
                this.scrollToTestimonial();
        });
        this.glide.mount();
    }
    /**
     * Reads the height of the navbar.
     */
    readNavbarHeight() {
        const navbar = document.querySelector('.navbar');
        this.navbarHeight = navbar !== null ? navbar.getBoundingClientRect().height : 0;
    }
    /**
     * Scrolls to the top of the testimonial.
     */
    scrollToTestimonial() {
        if (typeof this.glideTrackRef === 'undefined') {
            return;
        }
        const scrollOffset = window.pageYOffset;
        const glideTrackPosition = this.glideTrackRef.getBoundingClientRect().top;
        const buffer = 20;
        const top = scrollOffset + glideTrackPosition - this.navbarHeight - buffer;
        window.scrollTo({ top });
    }
    /**
     * Updates the height of the `.glide__track` element.
     */
    updateGlideTrackHeight() {
        if (typeof this.glideTrackRef === 'undefined') {
            return;
        }
        const activeSlide = document.querySelector('.glide__slide--active');
        const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
        const glideTrackHeight = this.glideTrackRef.offsetHeight;
        if (activeSlideHeight !== glideTrackHeight) {
            this.glideTrackRef.style.height = `${activeSlideHeight}px`;
        }
    }
};
__decorate([
    Ref('glideTrackRef')
], TestimonialsModuleUi.prototype, "glideTrackRef", void 0);
TestimonialsModuleUi = __decorate([
    Component({
        name: 'TestimonialsModuleUi',
        components: { ModuleHeaderUi },
        mounted() {
            this.readNavbarHeight();
            this.initGlide();
        },
        template: `
    <section class="testimonials-module" :style="{ background }">
      <div class="container">
        <div class="row justify-content-center">

          <!-- Heading -->
          <div class="col-12">
            <ModuleHeaderUi v-if="module.content.header" :header="module.content.header" />
          </div>

          <!-- Testimonials -->
          <div class="col-12 col-lg-8">
            <div v-if="module.content.testimonials && module.content.testimonials.length"
                 class="testimonials-module__slider glide">
              <!-- Slides -->
              <div class="glide__track" data-glide-el="track" ref="glideTrackRef">
                <ul class="glide__slides list-unstyled">
                  <li v-for="testimonial in module.content.testimonials" :key="testimonial.text"
                      class="glide__slide">

                    <!-- Single testimonial -->
                    <blockquote class="testimonial">
                      <!-- Text -->
                      <p class="testimonial__text">
                        {{ testimonial.text }}
                      </p>

                      <!-- Author -->
                      <cite class="testimonial__author">
                        <span class="testimonial__author__name">
                          {{ testimonial.author.name }}
                        </span>
                        <small class="testimonial__author__label">
                          {{ testimonial.author.label }}
                        </small>
                      </cite>
                    </blockquote>
                    <!-- END | Single testimonial -->

                  </li>
                </ul>
              </div>

              <!-- Pagination bullets -->
              <div class="glide__bullets" data-glide-el="controls[nav]">
                <button v-for="(testimonial, index) in module.content.testimonials" :key="testimonial.text"
                        class="glide__bullet" :data-glide-dir="'=' + index" />
              </div>
            </div>
          </div>
          <!-- END | Testimonials -->

        </div>
      </div>
    </section>
  `
    })
], TestimonialsModuleUi);
export { TestimonialsModuleUi };
